import { Directive, forwardRef, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator } from '@angular/forms';

@Directive({
    selector: '[validateEqual][formControlName],[validateEqual][formControl],[validateEqual][ngModel]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => EqualValidatorDirective),
            multi: true,
        },
    ],
})
export class EqualValidatorDirective implements Validator
{
    @Input()
    public reverse: string;

    @Input()
    public validateEqual: string;

    private get isReverse() {
        if (!this.reverse) {
            return false;
        }

        return this.reverse === 'true';
    }

    validate(thisControl: AbstractControl): { [key: string]: any } {
        const thisControlValue = thisControl.value;
        const thatControl = thisControl.root.get(this.validateEqual);

        // Values are not equal, no reverse.
        if (thatControl && thisControlValue !== thatControl.value && !this.isReverse) {
            return {validateEqual: true};
        }

        // Values equal, reverse.
        if (thatControl && thisControlValue === thatControl.value && this.isReverse) {
            if (thatControl.errors !== null) {
                if (thatControl.errors.hasOwnProperty('validateEqual')) {
                    delete thatControl.errors['validateEqual'];
                }

                if (!Object.keys(thatControl.errors).length) {
                    thatControl.setErrors(null);
                }
            }
        }

        // Values not equal, no reverse.
        if (thatControl && thisControlValue !== thatControl.value && this.isReverse) {
            thatControl.setErrors({validateEqual: true});
        }

        return null;
    }
}
